import {Box, Theme, withStyles} from '@material-ui/core';

export const PageContentContainer = withStyles((theme: Theme) => ({
  root: {
    width: '100%',
    height: 'auto',
    paddingTop: theme.spacing(2)
  },
}))(Box);
